import statementPNG from '~/assets/images/communication/statement.png'
import statementWEBP from '~/assets/images/communication/statement.webp'
import RatingScalePage from '~/pages/communication/libs/RatingScalePage'
import { STATEMENT_QUESTION } from '~/pages/communication/statement/libs/components/StatementCommunication/constants'
import { TPageProps } from '~/shared/types/commonTypes'

const StatementCommunication = (props: TPageProps) => (
  <RatingScalePage
    {...props}
    question={STATEMENT_QUESTION}
    titleI18nKey="onboarding.communicationStatement.title"
    subtitleI18nKey="onboarding.communicationStatement.subtitle"
    labelWeakI18nKey="onboarding.communicationStatement.labelDisagree"
    labelPowerfulI18nKey="onboarding.communicationStatement.labelAgree"
    imagePng={statementPNG}
    imageWebp={statementWEBP}
    imageAlt="Communication statement"
    contentGap={32}
  />
)

export default StatementCommunication
